import { render, staticRenderFns } from "./DialogWebhook.vue?vue&type=template&id=2603aeec"
import script from "./DialogWebhook.vue?vue&type=script&lang=js"
export * from "./DialogWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports